import * as utils from '@/components/partials/jobs/JobsInquiryForm/utils/common';
import * as sdrUtils from '@/components/partials/jobs/JobsInquiryForm/utils/sdrRoleUtils';
import {
  getDealSizeField,
  getQuotaAttainmentPerLastYearField,
} from '@/components/partials/jobs/JobsInquiryForm/utils/sectionFields';
import type {
  JobsSectionField,
  JobsSectionModels,
} from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export default ({ inquiry }: JobsSectionModels): JobsSectionField[] => {
  return [
    {
      attrs: {
        label: 'Measurement',
        value: sdrUtils.getSdrQuotaTypeFieldValue(inquiry),
      },
      fullWidth: true,
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) => utils.isMultiselectFieldHasSelectedOption(inquiry.sdrQuotaTypes),
    },
    {
      attrs: {
        label: 'Quota',
        value: inquiry?.sdrQuotaPerPeriod,
        attributeName: 'sdrQuotaPerPeriod',
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) => utils.isSingleFieldFilled(inquiry.sdrQuotaPerPeriod),
    },
    {
      attrs: {
        label: 'Quota attainment',
        value: utils.getQuotaAttainment(inquiry),
        attributeName: 'quotaAttainmentPerPeriod',
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) => utils.isSingleFieldFilled(inquiry.quotaAttainmentPerPeriod),
    },
    getQuotaAttainmentPerLastYearField({ inquiry }),
    getDealSizeField({ inquiry }),
  ];
};
